
import React ,{Component} from 'react'; 
import { NavLink,Outlet } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';


import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
export default class Layoutcontent extends Component {

   constructor(props) {
      super(props);
	  
      this.state = {
	  }
   }
      
	     
 
  

render()
{


  return (
 
  
    <React.Fragment> 
	<div className="main">
	
	
	<Outlet />

</div>
    </React.Fragment> 






  
	 );
}	 
	  
}
	
  
